import React, { ReactElement, useContext, useState } from 'react';
import { Popover } from 'syngenta-digital-cropwise-react-ui-kit';
import Info from 'assets/info.svg?react';
import DataMatchingPopoverContent from './DataMatchingPopoverContent';
import { Button } from 'antd';
import Close from 'assets/close.svg?react';
import { useTranslation } from 'react-i18next';
import { ConnectAuth, updateConnectAuthVisitedMapper } from 'models/AuthModel';
import { RootContext } from 'RootProvider';

const PopoverTitle = (props: { onClose: () => void }): ReactElement<any, any> => {
  const { t } = useTranslation();
  return (
    <div
      id="dataMatchingPopoverTitle"
      className={'data-matching-popover-title'}
      data-testid="dataMatchingPopoverTitle"
    >
      <span
        className={'data-matching-popover-title'}
        id="dataMatchingPopoverTitleText"
        data-testid="dataMatchingPopoverTitleText"
      >
        {t('What is data matching?')}
      </span>
      <Button
        type="text"
        id="whatIsDataMatchingButton"
        className="what-is-data-matching-button"
        onClick={props.onClose}
        data-testid="WhatIsDataMatchingButton"
      >
        <Close />
      </Button>
    </div>
  );
};

interface DataMatcherHeaderPopoverProps {
  connectAuth: ConnectAuth | undefined;
}

const DataMatcherHeaderPopover = (props: DataMatcherHeaderPopoverProps): ReactElement<any, any> => {
  const isUsersFirstVisit = String(props.connectAuth?.visitedMapper) === 'false' ? true : false;
  const [open, setOpen] = useState(isUsersFirstVisit);
  const { auth } = useContext(RootContext);

  const handleClose = () => {
    if (props.connectAuth && isUsersFirstVisit) {
      const connectAuth: ConnectAuth = props.connectAuth;
      connectAuth.visitedMapper = true;
      auth.setConnectAuth(connectAuth);
      updateConnectAuthVisitedMapper(connectAuth);
    }
    setOpen(false);
  };

  return (
    <div data-testid="DataMatcherHeaderPopover">
      <Popover
        placement="rightTop"
        title={<PopoverTitle onClose={handleClose} />}
        content={<DataMatchingPopoverContent />}
        trigger={'click'}
        open={open}
        onOpenChange={async (newOpen: boolean) => {
          setOpen(newOpen);
          if (props.connectAuth && isUsersFirstVisit && newOpen === false) {
            const connectAuth: ConnectAuth = props.connectAuth;
            connectAuth.visitedMapper = true;
            auth.setConnectAuth(connectAuth);
            updateConnectAuthVisitedMapper(connectAuth);
          }
        }}
      >
        <Info className="data-matching-info-icon" data-testid="DataMatchingInfoIcon" />
      </Popover>
    </div>
  );
};

export default DataMatcherHeaderPopover;
